// client/src/pages/LandingPage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function LandingPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    // ✅ FIX: prevent horizontal scroll on mobile
    <div className="min-h-screen overflow-x-hidden bg-gradient-to-br from-white to-slate-50 dark:from-slate-900 dark:to-slate-800 transition-colors">

      {/* HERO */}
      <section className="max-w-7xl mx-auto px-4 pt-20 pb-24 text-center">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-indigo-600 dark:text-indigo-400">
          CollegePal
        </h1>

        <p className="mt-6 text-lg sm:text-xl text-slate-600 dark:text-slate-300 max-w-3xl mx-auto">
          A campus-first platform to post tasks, recover lost items, build clubs,
          recruit members, and collaborate — all inside your college.
        </p>

        {/* ACTION BUTTONS */}
        {/* ✅ FIX: allow wrapping on small screens */}
        <div className="mt-10 flex items-center justify-center gap-4 flex-wrap max-w-full">
          <button
            onClick={() => navigate(user ? "/home" : "/login")}
            className="px-6 py-3 rounded-xl bg-indigo-600 text-white font-semibold shadow hover:bg-indigo-500 transition"
          >
            Get Started
          </button>

          <button
            onClick={() => navigate("/about")}
            className="px-6 py-3 rounded-xl border border-indigo-600 text-indigo-600 dark:text-indigo-400 dark:border-indigo-400 font-semibold hover:bg-indigo-50 dark:hover:bg-indigo-900/20 transition"
          >
            Learn More
          </button>
        </div>
      </section>

      {/* FEATURES */}
      <section className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">

          <div className="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow">
            <h3 className="text-xl font-bold text-indigo-600 dark:text-indigo-400">
              Tasks & Help
            </h3>
            <p className="mt-2 text-slate-600 dark:text-slate-300">
              Post tasks, help others, earn credits, and build real campus
              connections.
            </p>
          </div>

          <div className="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow">
            <h3 className="text-xl font-bold text-indigo-600 dark:text-indigo-400">
              Lost & Found
            </h3>
            <p className="mt-2 text-slate-600 dark:text-slate-300">
              Securely report lost items and reconnect them with their owners.
            </p>
          </div>

          <div className="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow">
            <h3 className="text-xl font-bold text-indigo-600 dark:text-indigo-400">
              Recruit / Clubs
            </h3>
            <p className="mt-2 text-slate-600 dark:text-slate-300">
              Create clubs, recruit members, manage applicants, and build teams.
            </p>
          </div>

          <div className="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow">
            <h3 className="text-xl font-bold text-indigo-600 dark:text-indigo-400">
              Real-time Chat
            </h3>
            <p className="mt-2 text-slate-600 dark:text-slate-300">
              One-to-one and group chats for tasks, clubs, and collaborations.
            </p>
          </div>

          <div className="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow">
            <h3 className="text-xl font-bold text-indigo-600 dark:text-indigo-400">
              Smart Notifications
            </h3>
            <p className="mt-2 text-slate-600 dark:text-slate-300">
              Never miss messages, updates, selections, or task activity.
            </p>
          </div>

          <div className="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow">
            <h3 className="text-xl font-bold text-indigo-600 dark:text-indigo-400">
              Built for Campuses
            </h3>
            <p className="mt-2 text-slate-600 dark:text-slate-300">
              Designed specifically for college environments and student needs.
            </p>
          </div>

        </div>
      </section>

      {/* PREVIEW / CTA */}
      <section className="max-w-7xl mx-auto px-4 py-20 text-center">
        <div className="bg-gradient-to-br from-indigo-500/10 to-purple-500/10 dark:from-indigo-900/20 dark:to-purple-900/20 rounded-3xl p-10 border border-indigo-200 dark:border-indigo-800 max-w-full">
          <h2 className="text-3xl sm:text-4xl font-bold text-indigo-700 dark:text-indigo-300">
            Start building your campus community
          </h2>

          <p className="mt-4 text-slate-600 dark:text-slate-300 max-w-2xl mx-auto">
            CollegePal brings tasks, clubs, lost items, and conversations into
            one trusted space.
          </p>

          {/* ✅ FIX: buttons wrap on mobile */}
          <div className="mt-8 flex items-center justify-center gap-4 flex-wrap">
            <button
              onClick={() => navigate(user ? "/home" : "/register")}
              className="px-8 py-3 rounded-xl bg-indigo-600 text-white font-semibold hover:bg-indigo-500 transition"
            >
              Join Now
            </button>

            <button
              onClick={() => navigate("/help")}
              className="px-8 py-3 rounded-xl border border-indigo-600 text-indigo-600 dark:text-indigo-400 dark:border-indigo-400 font-semibold hover:bg-indigo-50 dark:hover:bg-indigo-900/20 transition"
            >
              How it Works
            </button>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="text-center py-10 text-sm text-slate-500 dark:text-slate-400">
        Built with ❤️ by students, for students.
      </footer>
    </div>
  );
}
